import { render, staticRenderFns } from "./MenusContainer.vue?vue&type=template&id=89e61f62"
import script from "./MenusContainer.vue?vue&type=script&lang=js"
export * from "./MenusContainer.vue?vue&type=script&lang=js"
import style0 from "./MenusContainer.vue?vue&type=style&index=0&id=89e61f62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports